var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide-down-fade" } }, [
    !_vm.defaultOptionSelected
      ? _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasOptions,
                expression: "hasOptions"
              }
            ],
            staticClass: "options-selector-container",
            class: { "options-selector-container--invalid": _vm.isInvalid },
            on: {
              click: function($event) {
                return _vm.$emit("click")
              }
            }
          },
          [
            _vm.disabled ? _c("div", { staticClass: "box" }) : _vm._e(),
            _vm._v(" "),
            _c(
              "select",
              {
                staticClass: "options-selector",
                class: { "options-selector--invalid": _vm.isInvalid },
                attrs: { name: _vm.name, id: _vm.id, disabled: _vm.disabled },
                on: { change: _vm.optionChanged }
              },
              [
                _c(
                  "option",
                  {
                    attrs: { value: "" },
                    domProps: { selected: _vm.emptyOptionSelected }
                  },
                  [_vm._v(_vm._s(_vm.validationMessage || _vm.defaultValue))]
                ),
                _vm._v(" "),
                _vm._l(_vm.options, function(option) {
                  return _c(
                    "option",
                    {
                      key: option.product_option_value_id,
                      domProps: {
                        value: option.product_option_value_id,
                        selected:
                          _vm.selectedValue === option.product_option_value_id
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(option.product_option_value_title) +
                          "\n                "
                      ),
                      _c(
                        "transition",
                        { attrs: { name: "fade" } },
                        [_vm._t("option-sidetitle", null, { option: option })],
                        2
                      )
                    ],
                    1
                  )
                })
              ],
              2
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7978e58b", { render: render, staticRenderFns: staticRenderFns })
  }
}